// extracted by mini-css-extract-plugin
module.exports = {"project-links":"ProjectLinks_project-links__1tBei","live-link":"ProjectLinks_live-link__3E1qO","repo-link":"ProjectLinks_repo-link__Z6Q6f"};